import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox, Paragraph } from '@digdir/designsystemet-react';
import { Fragment } from 'react';

import { OppvarmingFormData } from '../../../../../types';
import { StyledCard } from '../../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { useOppvarmingValidation } from '../../../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../../../utils';
import { InstallasjonsArRadio } from '../../../../../../../components/installasjonsArRadio';

import { InstallertIOppvarmetRomRadio } from './installertIOppvarmetRomRadio';

export const Varmtvannsbereder = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const { t } = useTranslation();

  const varmtvannsberederSelected = watch('elektrisk.value.varmtvannsbereder.selected');

  return (
    <StyledCard isActive={varmtvannsberederSelected}>
      <Checkbox
        aria-invalid={!!formState.errors.elektrisk?.value?.varmtvannsbereder?.selected}
        label={t('form.oppvarming.elektrisitet.varmtvannsbereder.label')}
        {...register('elektrisk.value.varmtvannsbereder.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {varmtvannsberederSelected && (
        <Fragment>
          <Paragraph className="text-preline">
            {t('form.oppvarming.elektrisitet.varmtvannsbereder.description')}
          </Paragraph>
          <InstallasjonsArRadio
            name={`elektrisk.value.varmtvannsbereder.value`}
            translationKeyPrefix={`form.oppvarming.elektrisitet.varmtvannsbereder.installasjonsAr`}
          />
          <InstallertIOppvarmetRomRadio />
        </Fragment>
      )}
    </StyledCard>
  );
};
